import apiClient from "./apiClient";

// Định nghĩa kiểu dữ liệu
export interface Notification {
  id: number;
  title: string;
  body: string;
  read: boolean;
  created_at: string;
  type: string;
  data?: any;
}

export interface FCMDeviceRegistration {
  token: string;
  device_type: string;
  device_id: string;
  app_version: string;
  platform_version: string;
}

export interface FCMDeviceResponse {
  id: number;
  user_id: number;
  token: string;
  device_type: string;
  is_active: boolean;
}

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

// API Service cho thông báo
export const notificationService = {
  // Lấy danh sách thông báo
  getNotifications: async () => {
    const response = await apiClient.get<ApiResponse<Notification[]>>("/api/notifications");
    return response;
  },

  // Đánh dấu thông báo đã đọc
  markAsRead: async (notificationId: number) => {
    const response = await apiClient.put<ApiResponse<any>>(`/api/notifications/${notificationId}/read`, {});
    return response;
  },

  // Đánh dấu tất cả thông báo đã đọc
  markAllAsRead: async () => {
    const response = await apiClient.put<ApiResponse<any>>("/api/notifications/read-all", {});
    return response;
  },

  // Xóa thông báo
  deleteNotification: async (notificationId: number) => {
    const response = await apiClient.delete<ApiResponse<any>>(`/api/notifications/${notificationId}`);
    return response;
  },

  // Đăng ký token FCM
  registerToken: async (deviceInfo: FCMDeviceRegistration) => {
    const response = await apiClient.post<ApiResponse<FCMDeviceResponse>>("/api/notifications/register-token", deviceInfo);

    if (response.success) {
      localStorage.setItem("fcmTokenSent", "true");
      localStorage.setItem("fcmTokenSaved", deviceInfo.token);
    }

    return response;
  }
};

export default notificationService; 